import { Stack, Typography } from "@mui/material";
import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { ThemeModeContext } from "../../shared/Theme";
import { green } from "../../shared/colours";

const HubInfoCard = (props) =>
{

	const navigate = useNavigate();
	const themeModeContext = useContext(ThemeModeContext);

	return (
		<React.Fragment>
			<Stack
				direction="column"
				spacing={0.1}
				alignItems="center"


				sx={{
					width: "20em",
					height: "25em",
					border: `solid 2px ${green}`,
					borderRadius: "1.5em",
					paddingTop: "0.5em",
					overflow: "hidden",
					visibility: props.isVisible ? 'visible' : 'hidden',
					// display: props.isVisible ? 'block':'none'
				}}
			>
				<Typography
					variant="h6"
					sx={{
						textAlign: "center",
						marginTop: "1em",
						paddingBottom: "0.5em",
						cursor: "pointer",
						fontWeight: "bold"
					}}

				>
					{props.title}
				</Typography>
				{props.children}
			</Stack>
		</React.Fragment>
	);

}

export default HubInfoCard;